import { lazy } from "react";

export const lazyImport = importFunction =>
	lazy(() => new Promise(resolve => importFunction().then(resolve).catch(window.jsobject?.reload)));
